import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/intents")({
  component: lazyRouteComponent(() => import("@/pages/admin/Intents")),
});
